<template>
    <div class="main-form">
        <div v-if="loading" class="loader-mask" >
            <span class="loader"></span>
        </div>
        <div v-else >
            <div class="main-form_info">
                <TitleAndExplanation 
                    :title = "$store.state.newTexts.step_datos_personales[0].title"
                    :explanation = "$store.state.newTexts.step_datos_personales[0].explanation"
                ></TitleAndExplanation>
                <ValidationObserver ref="formObserver">
                    <!-- Datos personales-->
                    <DatosPersonales />
                </ValidationObserver>
            </div>
            <NavegationButtons 
                :nextStepButtonActive = "canContinue"
                nextStepButtonText = "Enviar"
                backStepButtonText = "Atrás"
                :nextStepCallback = sendData 
            ></NavegationButtons>
        </div>
    </div>
</template>

<script>
import TitleAndExplanation from '../common/TitleAndExplanation.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import DatosPersonales from '../common/DatosPersonales.vue'
import { ValidationObserver } from "vee-validate";

export default {
    name: 'step_datos_personales',
    components: {
        ValidationObserver,
        TitleAndExplanation,
        NavegationButtons,
        DatosPersonales
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        canContinue(){
            const { nombre, apellidos, telefono, prefijo, email, my_hello_check } = this.$store.state.prescoringData;
            return nombre !== null && nombre !== ''
                    && apellidos !== null && apellidos !== ''
                    && telefono !== null && prefijo !== null && telefono !== '' && prefijo !== '' && telefono.length >= 9
                    && email !== null && email !== ''
                    && my_hello_check !== null && my_hello_check == true;
        }
    },
    methods: {
        async sendData() {            
            const isValid = await this.$refs.formObserver.validate();
            if (isValid) {
                this.loading = true;
                const response = await this.$store.dispatch('registrarLead');
                if(response.resultado.equipo_trabajo == 'myinvestor'){
                    this.loading = false;
                    this.$store.dispatch('goNext', 'ok_view_my');
                } else {
                    this.loading = false;
                    this.$store.dispatch('goNext', 'ok_view_helloteca');
                } 
            } else {
                // El formulario tiene errores
                console.log('Por favor, corrige los errores.');
            }
        }
    }
}
</script>

<style scoped>
    /* LOADER */
    .loader-mask {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9); 
        z-index: 99;
    }
    .loader {
        border: 8px solid var(--gray-light);
        border-top: 8px solid var(--primary); 
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 2s linear infinite;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

</style>